"use client";

import { FaEnvelope, FaPhone } from "react-icons/fa";
import ContactCard from "../landing-page/ContactCard";

const WHATSAPP_LINK_URL = process.env.NEXT_PUBLIC_WHATSAPP_LINK_URL;

const CustomerSupportSection = () => {
  return (
    <section className="py-10 md:py-20 bg-gray-50">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
        {/* Text Content */}
        <div className="flex flex-col space-y-3 md:space-y-4 text-start">
          <p className="text-blue-500 font-semibold uppercase text-sm md:text-md">
            CUSTOMER SUPPORT
          </p>

          <h2 className="text-xl md:text-3xl font-bold text-black">
            Support for every problem
          </h2>

          <p className="text-gray-600 text-sm md:text-lg">
            We'd love to help you resolve your problem.
          </p>
        </div>

        {/* Single Combined Contact Card */}
        <div>
          <ContactCard
            icon1={FaEnvelope}
            title1="Write to us at"
            contact1="support@carer.ai"
            link1="mailto:support@carer.ai"
            icon2={() => (
              <FaPhone className="text-blue-400 rotate-90" />
            )}
            title2="Call us on"
            contact2="+91 7701 858 315"
            link2="tel:+917701858315"
            whatsappLink={WHATSAPP_LINK_URL}
          />
        </div>
      </div>
    </section>
  );
};

export default CustomerSupportSection;
